import { AlertTriangle, RefreshCw, MapPin } from 'lucide-react';
import { Card } from '@/components/ui/card';

interface MapErrorFallbackProps {
  onRetry?: () => void;
  className?: string;
}

export function MapErrorFallback({
  onRetry,
  className = '',
}: MapErrorFallbackProps) {
  return (
    <div
      className={`flex items-center justify-center bg-gray-100 ${className}`}
    >
      <Card className="w-full max-w-md p-8 border-red-200 bg-red-50 m-4">
        <div className="text-center">
          <div className="relative mb-4">
            <MapPin className="h-16 w-16 text-red-300 mx-auto" />
            <AlertTriangle className="h-8 w-8 text-red-500 absolute -top-1 -right-1 bg-red-50 rounded-full p-1" />
          </div>
          <h3 className="text-xl font-medium text-red-900 mb-2">
            Map Failed to Load
          </h3>
          <p className="text-sm text-red-700 mb-6">
            Unable to load the map component. This could be due to network
            issues or Google Maps API problems.
          </p>
          {onRetry && (
            <button
              onClick={onRetry}
              className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium text-red-700 bg-white border border-red-300 rounded-lg hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-colors"
            >
              <RefreshCw className="h-4 w-4" />
              Reload Map
            </button>
          )}
        </div>
      </Card>
    </div>
  );
}
